import Step1Image from '@public/pricing/dnakit-desktop.webp';
import Image from 'next/image';
import Link from 'next/link';

const PricingStep1Section = () => {
  return (
    <section className="px-6 md:px-20 py-10 md:py-20">
      <div className="width-1440 flex flex-col lg:flex-row lg:justify-between items-center gap-8 lg:gap-20">
        <div className="flex flex-col gap-4 lg:w-1/3">
          <p className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-black text-white font-light text-2xl">
            1
          </p>
          <h2 className="font-light text-3.5xl lg:text-[42px] leading-snug">
            Get your DNA health & fitness plan
          </h2>
          <p className="font-light flex items-center gap-2">
            <span className="text-alter-black text-3.5xl">$89</span>
            <span className="line-through text-alter-black-80 text-2xl">$99</span>
          </p>
          <p className="font-light text-lg text-alter-black-80">
            Unlock your personalized fitness and nutrition insights with our comprehensive DNA test.
          </p>
          <Link
            href="/shop/swab-kit"
            className="flex items-center gap-2 bg-black text-white px-11 py-3 mt-2 rounded-full w-min whitespace-nowrap"
          >
            <span className="hidden lg:inline">Get your DNA Health & Fitness Plan</span>
            <span className="lg:hidden">Shop Now </span>
            <span className="text-xl">→</span>
          </Link>
        </div>
        <div className="lg:w-2/3">
          <Image
            src={Step1Image}
            alt="Get your DNA health & fitness plan"
            className="object-cover w-full h-auto"
            priority
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
};

export default PricingStep1Section;
